import React from 'react';
import { User, Camera } from 'lucide-react';
interface ProfilePictureUploadProps {
  selectedAvatar: string | null;
  onSelect: (avatar: string) => void;
}
const AVATAR_OPTIONS = ['👨‍🍳', '👩‍🍳', '🥘', '🥗', '🍜', '🌮', '🥑', '🥕'];
export function ProfilePictureUpload({
  selectedAvatar,
  onSelect
}: ProfilePictureUploadProps) {
  return <div className="space-y-4" data-id="element-195">
      <label className="block font-mono text-sm uppercase tracking-wider text-gray-500" data-id="element-196">
        Profile Identity
      </label>

      <div className="flex flex-col sm:flex-row gap-8 items-start" data-id="element-197">
        {/* Current Selection Preview */}
        <div className="w-32 h-32 border-2 border-dashed border-gray-300 flex items-center justify-center bg-gray-50" data-id="element-198">
          {selectedAvatar ? <span className="text-6xl" data-id="element-199">{selectedAvatar}</span> : <User className="w-12 h-12 text-gray-300" data-id="element-200" />}
        </div>

        {/* Selection Grid */}
        <div className="flex-1 space-y-4" data-id="element-201">
          <div className="grid grid-cols-4 gap-4" data-id="element-202">
            {AVATAR_OPTIONS.map(avatar => <button key={avatar} type="button" onClick={() => onSelect(avatar)} className={`h-16 border-2 flex items-center justify-center text-2xl transition-all ${selectedAvatar === avatar ? 'border-gray-800 bg-white shadow-sm' : 'border-gray-200 hover:border-gray-400 bg-white/50'}`} data-id="element-203">
                {avatar}
              </button>)}
          </div>
          <div className="flex items-center justify-center border-2 border-dashed border-gray-200 p-4 text-gray-400 text-sm font-mono cursor-not-allowed opacity-60" data-id="element-204">
            <Camera className="w-4 h-4 mr-2" data-id="element-205" />
            <span data-id="element-206">Upload Custom Image (Disabled)</span>
          </div>
        </div>
      </div>
    </div>;
}